<div class="img-container">
  <img [ngClass]="'border-radius-' + borderRadius"
       [ngSrc]="base64 ?? src ?? '/assets/img/placeholders/' + placeholder + '.png'"
       [height]="height || size"
       [style.objectFit]="objectFit"
       [width]="width || size" />
</div>
